var map = {
	"./views/branch/branch.module": [
		"./src/app/views/branch/branch.module.ts",
		"default~views-branch-branch-module~views-user-user-module",
		"views-branch-branch-module"
	],
	"./views/dashboard/dashboard.module": [
		"./src/app/views/dashboard/dashboard.module.ts",
		"default~views-dashboard-dashboard-module~views-models-managements-models-managements-module~views-se~4c7f0def",
		"common",
		"views-dashboard-dashboard-module"
	],
	"./views/desks/desks.module": [
		"./src/app/views/desks/desks.module.ts",
		"common",
		"views-desks-desks-module"
	],
	"./views/devices/devices.module": [
		"./src/app/views/devices/devices.module.ts",
		"common",
		"views-devices-devices-module"
	],
	"./views/models-managements/models-managements.module": [
		"./src/app/views/models-managements/models-managements.module.ts",
		"default~views-dashboard-dashboard-module~views-models-managements-models-managements-module~views-se~4c7f0def",
		"views-models-managements-models-managements-module"
	],
	"./views/pending-tickets/pending-tickets.module": [
		"./src/app/views/pending-tickets/pending-tickets.module.ts",
		"common",
		"views-pending-tickets-pending-tickets-module"
	],
	"./views/privileges/privilege.module": [
		"./src/app/views/privileges/privilege.module.ts",
		"common",
		"views-privileges-privilege-module"
	],
	"./views/profile/profile.module": [
		"./src/app/views/profile/profile.module.ts",
		"common",
		"views-profile-profile-module"
	],
	"./views/queue-ticket/queue-ticket.module": [
		"./src/app/views/queue-ticket/queue-ticket.module.ts",
		"common",
		"views-queue-ticket-queue-ticket-module"
	],
	"./views/report/report.module": [
		"./src/app/views/report/report.module.ts",
		"common",
		"views-report-report-module"
	],
	"./views/roles/role.module": [
		"./src/app/views/roles/role.module.ts",
		"common",
		"views-roles-role-module"
	],
	"./views/service/service.module": [
		"./src/app/views/service/service.module.ts",
		"default~views-dashboard-dashboard-module~views-models-managements-models-managements-module~views-se~4c7f0def",
		"common",
		"views-service-service-module"
	],
	"./views/ticket/ticket.module": [
		"./src/app/views/ticket/ticket.module.ts",
		"common",
		"views-ticket-ticket-module"
	],
	"./views/user/user.module": [
		"./src/app/views/user/user.module.ts",
		"default~views-branch-branch-module~views-user-user-module",
		"common",
		"views-user-user-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;